import { Text } from '@capsicum/common-web';
import styled from 'styled-components';

export const Title = styled(Text)`
	text-align: center;
	text-transform: uppercase;
`;

export const Description = styled(Text)`
	text-align: center;
`;
